import {STORAGE_KEYS} from "../utils/constants/storageKeys";
const BASE_URL = process.env.REACT_APP_BASE_API_URL;

/**
 * A generic API request function.
 * @param {string} endpoint - The endpoint after /api/.
 * @param {object} options - Fetch options.
 * @param {string} options.method - GET, POST, etc.
 * @param {object} [options.body] - Request payload.
 * @param {boolean} [options.requiresAuth=true] - Whether to attach the token.
 * @returns {Promise<object>} - Parsed JSON data or throws error.
 */
const apiCall = async (endpoint, { method = "GET", body = null, requiresAuth = true } = {}) => {
  const url = `${BASE_URL}${endpoint}`;
  const headers = {};

  const isFormData = body instanceof FormData;

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  if (requiresAuth) {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN) || sessionStorage.getItem(STORAGE_KEYS.TOKEN);
    if (!token) throw new Error("Authentication token not found.");
    headers["Authorization"] = `Bearer ${token}`;
  }

  const config = {
    method,
    headers,
    body: body ? isFormData ? body : JSON.stringify(body) : undefined,
  };

  const response = await fetch(url, config);
  const data = response.status !== 204 ? await response.json() : null;

  if (!response.ok) {
    throw new Error(data.message || "API call failed");
  }

  return data;
};

export default apiCall;
